<template>
    <div class="page-content">
        <h1>Cookies</h1>
        <hr />
        <h2> Cookies, tracking tags &amp; similar technologies</h2>
        <p> Our services use cookies and other similar technologies, such as tracking tags, to help provide you with a better, faster, safer and more personalised experience.</p>
        <h3>Cookies</h3>
        <p> Cookies are small text files that your computer or mobile device downloads and stores on your browser when you visit a website. When you return to a website, it recognises these cookies stored on your browser.</p>
        <h3> Device information</h3>
        <p> Each time you visit our website from any device (mobile, tablet, laptop or desktop), we collect information about the device or browser you are using and we may use this information to help us monitor your use of our website and other services. Where this information is used to try and create a unique identifier for you, it is known as device fingerprinting, which we may do to improve your security and convenience. We do not use device fingerprinting to support our marketing.</p>
        <h3>Local storage</h3>
        <p>Local storage is an industry-standard technology that allows a website or application to store information locally on your computer or mobile device.</p>
        <h2>Which cookies do we use?</h2>
        <p>We only use necessary cookies.</p>
        <h3>Necessary cookies</h3>
        <p>These enable the core functionality of our website. They are essential and can only be disabled through changing your browser settings. If you do switch off these cookies in your browser, parts of our website may not work correctly. These cookies allow you to log in to secure areas of our site, move around the site and use its features. They also ensure your security and privacy when using our website. These cookies don't gather information about you.</p>
        <p>We've outlined how we use these cookies in the table below:</p>
        <table>
            <thead>
                <tr>
                    <th>Cookie name</th>
                    <th>Detail</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>TableauWebsite.Session</td>
                    <td>Used to keep trace of website session</td>
                </tr>
                <tr>
                    <td>XSRF-TOKEN</td>
                    <td>Used to prevent any cross site request forgery</td>
                </tr>
                <tr>
                    <td>.AspNetCore.Antiforgery.xxxxxxxxxxx</td>
                    <td>Used to prevent any cross site request forgery</td>
                </tr>
                <tr>
                    <td>sid</td>
                    <td>Used by OKTA for authentication/authorization</td>
                </tr>
                <tr>
                    <td>oktaStateToken</td>
                    <td>Used by OKTA for authentication/authorization</td>
                </tr>
                <tr>
                    <td>Okta_Verify_Autopush_xxxxxxxxxx</td>
                    <td>Used by OKTA for authentication/authorization</td>
                </tr>
                <tr>
                    <td>JSESSIONID</td>
                    <td>Used by OKTA for authentication/authorization</td>
                </tr>
                <tr>
                    <td>DT</td>
                    <td>Used by OKTA for authentication/authorization</td>
                </tr>
                <tr>
                    <td>cookies_consent</td>
                    <td>Used to record acceptance of the cookie message</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>


<style lang="scss" scoped>
    @use 'sass:math';
    @import '../../styles/base';
    @import '../../../node_modules/hd-styles/modules/mixins';

    $border: $border-width-light solid $grey;

    .page-content {
        max-width: $feed-width;
        margin: 0 auto;
        height: auto;
    }

    table {
        width: 100%;
        border-radius: $border-radius-large;
        border: $border;
        border-spacing: 0;
        overflow: hidden;
        margin-bottom: $spacing-unit;
    }

    td, th {
        padding: math.div($spacing-unit, 2);
        border-right: $border;

        &:last-child {
            border-right: none;
        }
    }

    tr:nth-child(2n), thead tr {
        background-color: $grey-blue;
    }

    th {
        font-weight: 700;
        border-bottom: $border;
    }
</style>
